import React, { useEffect, useRef } from "react";
import { useClickAway } from "@uidotdev/usehooks";

interface SizePickerProps {
  isActive?: boolean;
  sizes: {
    onClick: () => void;
    value: string;
    disabled?: boolean;
  }[];
  onDismiss?: () => void;
}

export const SizePicker = ({ isActive, sizes, onDismiss }: SizePickerProps) => {
  let overlayRef = useRef<HTMLDivElement | null>(null);

  const ref = useClickAway(() => {
    if (isActive) {
      onDismiss?.();
    }
  });

  useEffect(() => {
    if (isActive) {
      overlayRef.current = document.createElement("div");
      overlayRef.current.classList.add("generic-overlay");
      document.body.appendChild(overlayRef.current);
      setTimeout(() => {
        overlayRef.current?.classList.add("show");
      }, 10);
    } else {
      overlayRef.current?.remove();
    }
  }, [isActive]);

  return (
    <div
      ref={ref}
      className="maxLg:fixed maxLg:bottom-[-208px] maxLg:left-0 maxLg:right-0 maxLg:rounded-t-2xl maxLg:pb-4 maxLg:z-[100] bg-neutrals-lightGrey transition-all group-[.is-active]:bottom-0"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <div className="lg:hidden px-8 pb-4 pt-8 text-lg font-medium text-brand-bistre">Select size</div>
      <div className="grid grid-cols-8 lg:grid-cols-6 xl:grid-cols-8 gap-0">
        {sizes.map((size, i) => (
          <button
            key={i}
            className={`maxXl:min-w-[52px] h-[60px] text-base ${size.disabled ? "text-neutrals-midGrey" : "text-brand-bistre"}`}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              size.onClick();
            }}
            disabled={size.disabled}
          >
            {size.value}
          </button>
        ))}
      </div>
    </div>
  );
};
